import React from "react";
import TestDefinitionItem from "./TestDefinitionItem";
import Forms from '../../../bricks/form/Forms';

import "./OtherTestItem.scss";

const OtherTestItem = ({test, onTestChange, onFileChange, disabled = false}) => {

    const handleTestDefinitionChange = (index) => (newItem) => {
        const newTestDefinitionList = [...test.testDefinitionList];
        newTestDefinitionList[index] = newItem;
        onTestChange({...test, testDefinitionList: newTestDefinitionList});
    };

    const addTestDefinitionItem = () => {
        const newTestDefinitionList = [...test.testDefinitionList, {order: 0, min: 0, max: 0}];
        onTestChange({...test, testDefinitionList: newTestDefinitionList});
    };

    const handleFieldChange = (name, value) => {
        onTestChange({
            ...test,
            [name]: value
        });
    };

    return (
        <div className="OtherTestItem">
            <h4>Test: <strong>{test.name}</strong></h4>
            <div className="row">
                <div className="col-6">
                    <Forms.Text
                        name="name"
                        label="Název testu"
                        value={test.name || ''}
                        onChange={handleFieldChange}
                        disabled={disabled}
                        required
                    />
                </div>
                <div className="col-6">
                    <Forms.Number
                        name="percentPassedThreshold"
                        label="Hranice pro splnění testu v %"
                        value={test.percentPassedThreshold ?? ''}
                        onChange={handleFieldChange}
                        max={100}
                        disabled={disabled}
                        min={0}
                    />
                </div>
                <div className="col-6">
                    <Forms.File
                        onChange={onFileChange}
                        label="Otázky"
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="testContainer">
                <h4>Nastavení testů <Forms.AddIcon size={22} onClick={addTestDefinitionItem}/></h4>
                {test.testDefinitionList.map((item, index) => (
                    <TestDefinitionItem
                        key={index}
                        disabled={disabled}
                        index={index}
                        item={item}
                        onChange={handleTestDefinitionChange(index)}
                        isLastItem={index === test.testDefinitionList.length - 1}
                    />
                ))}
            </div>
        </div>
    );
}


export default OtherTestItem;